// components/removal-copy.js: B4a-A9 pure copy for the removed-from-room
// screen. A removed player lands on the home page, so the button reads
// "Back to home" and goes home (dismissRemoval resets to the choose
// step). Kept here so node:test can pin the exact strings.

/** The removal banner per reason. */
export function removalMessage(reason) {
  return reason === 'kicked'
    ? 'You were removed from the room.'
    : 'The room was closed.';
}

/** The dismiss button always returns to the home screen. */
export const REMOVAL_BUTTON_LABEL = 'Back to home';
